import { useContext } from "react";
import { AuthContext, AuthContextType } from "../containers/AuthContainer/AuthContainer";

const useAuthContext = (): AuthContextType => {
  return useContext(AuthContext);
};

export default useAuthContext;
